function Laptop() {
    return (
        <div>
            <div className="image-two" data-testid="laptopimg">
                <img src="./jonh_sv_vrsxva.svg" alt="" />
            </div>
        </div>
    )
};

export default Laptop;
